import { safeCssBackgroundImageUrl } from '../../utils/safeCssBackgroundImageUrl';
import { safeCssColor } from '../../utils/safeCssColor';
import type { ProfileViewModel } from './profileViewModel';

const THEME_BACKDROP: Record<string, string> = {
  editoriale: '#FAF8F5',
  notte: '#1A1A1A',
  costiera: '#1d3a3a',
  terra: '#E8DFD3',
};

const CUSTOM_BG_FALLBACK = '#0a1218';
const DEFAULT_BACKDROP = '#d9d2c7';

export function getProfilePageBackdrop(vm: ProfileViewModel): string {
  if (safeCssBackgroundImageUrl(vm.backgroundImageUrl)) {
    return safeCssColor(vm.backgroundColor) ?? CUSTOM_BG_FALLBACK;
  }
  return THEME_BACKDROP[vm.themeId] ?? DEFAULT_BACKDROP;
}
